
<div v-if="show" class="UpdateOverlay">
    <div ref="content" class="UpdateOverlay-content">
        <div class="UpdateOverlay-text">
            <span class="UpdateOverlay-title"
                >Neue Version verfügbar. Bitte aktualisieren Sie die App.</span
            >
        </div>
        <Button variant="success" @onClick="reloadPage"> Aktualisieren </Button>
    </div>
</div>
